import { render } from "./MessagesNew.vue?vue&type=template&id=563490ed&scoped=true"
import script from "./MessagesNew.vue?vue&type=script&lang=js"
export * from "./MessagesNew.vue?vue&type=script&lang=js"

import "./MessagesNew.vue?vue&type=style&index=0&id=563490ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563490ed"]])

export default __exports__